module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-scary.d1e211c0.png";